export function cep_mask(v: any) {
  v = v.replace(/D/g, '');
  v = v.replace(/^(\d{5})(\d)/, '$1-$2');
  return v;
}
